<template>
  <div>
    <h1>We'd love to hear from you!</h1>
    <p>
      We appreciate it if you can share your experience using our platform. This will help us better understand what you liked most and how we can get even better.
    </p>

    <v-row v-if="(!mood) || false" class="mb-8 mx-0 align-center">
      <v-col cols="12" class="mb-0 pb-0">
        <h3 class="mb-0 pb-0">Are you happy with your experience?</h3>
      </v-col>
      <v-col cols="12" sm="4">
        <BigButton 
          elevated 
          icon="fal fa-smile"
          icon-color="black" 
          title="Yes, all good!" 
          text="" 
          @click="vote('happy')"
          />
      </v-col>
      <v-col cols="12" sm="4">
        <BigButton 
          elevated 
          icon="fal fa-meh"
          icon-color="black"
          title="Could've been better" 
          text="" 
          @click="vote('neutral')"
          />
      </v-col>
      <v-col cols="12" sm="4">
        <BigButton 
          elevated 
          icon="fal fa-frown"
          icon-color="black"
          title="Not so much" 
          text="" 
          @click="vote('unhappy')"/>
      </v-col>
    </v-row>


    <div v-if="mood=='happy'">
      <h3>Thank you for your feedback!</h3>
      <p>
        We're thrilled to hear you had a great experience!
      </p>
      <v-alert type="info">
        <h3>Share a review and get 50% discount on the setup-service of your next event!</h3>
        <p>When you share a review on Capterra and let us know about it, we will give you a 50% discount on the setup-service of your next event!</p>
      </v-alert>
      <p>
        <v-btn outlined color="primary" to="/r/go/review">Share a Review</v-btn>
      </p>
      
    </div>

    <div v-if="mood=='neutral'">
      <h3>Thank you for your feedback!</h3>
      <p>
        We noticed your experience was okay but not outstanding. If there's anything we can do to make it better, we'd love to hear your thoughts. Your feedback helps us improve and provide the best service possible.
      </p>
      <p>
        <v-btn outlined color="primary" to="/contact">Provide Feedback</v-btn>
      </p>

    </div>
    <div v-if="mood=='unhappy'">
      <h3>We're sorry to hear that you're not happy!</h3>
      <p>Your feedback is incredibly important to us, and we'd greatly appreciate it if you could take a moment to let us know what went wrong or how we can improve. Your insights help us make things better for everyone.</p>
      <p>Thank you for helping us improve!</p>
      <p>
        <v-btn outlined color="primary" to="/contact">Provide Feedback</v-btn>
      </p>
    </div>

  </div>
</template>


<script>
import siteData from '@/data/site.json'
import { mapGetters } from "vuex";
import profileService from "@/services/profileService";
import BigButton from "@/components/BigButton";
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

export default {
  name: "ShareFeedback",
  components: {
    BigButton,
  },
  props: {
  },
  data: function() {
    return {
      tenant: tenant,
      siteData: siteData,
      mood: null,
    };
  },
  created() {
  },
  beforeDestroy () {
  },
  async mounted() {

  },
  methods: {
    async vote(option) {
      this.mood = option;
      await profileService.vote('eventmanager-completion-feedback', option, {
        event_id: this.$route.query.eventId,
      });
    }
   
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
};
</script>

<style scoped>
</style>